import { Component, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { PlatformApiService } from '../../services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';
import { UserCredential} from '../../models/AccountModel';
import { WizardScreenComponent } from 'src/app/shared/wizard.component';
import { CognitoService } from 'src/app/services/cognito.service';
import { environment } from 'src/environments/environment';
import { OidcConnectWiseService } from 'src/app/services/oidc.service';
import { AuthenticationType } from 'src/app/services/oidc.factory';
import { Router } from '@angular/router';

@Component({
  selector: 'cw-ci-profile-linked-accounts',
  templateUrl: './profile-linked-accounts.component.html',
  styleUrls: ['./profile-linked-accounts.component.scss'],
  providers: [{provide: WizardScreenComponent, useExisting: forwardRef(() => ProfileLinkedAccountsComponent)}]
})
export class ProfileLinkedAccountsComponent extends WizardScreenComponent {
  @ViewChild('disconnectButton', {static:true}) disconnectButton: ElementRef;
  private userCreds: UserCredential[];
  public ssoConnected = false;
  public onlyHasCwSsoCreds = false;
  public loggedInDirectly: boolean;

  constructor(private _sessionService: SessionService, private _apiService: PlatformApiService, private _cognitoService: CognitoService, private _oidcCwService: OidcConnectWiseService, private _router: Router) {
    super();
    this.loggedInDirectly = this._sessionService.getAuthenticationType() == AuthenticationType.COGNITO;
  }

  onLoad() {
    this.ssoConnected = false;
    this.showSpinner();
    this._apiService.getAccountUserCredentials(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id).subscribe(
      usrCreds=> {
        this.userCreds = usrCreds;
        this.onlyHasCwSsoCreds = true;
        usrCreds.forEach(cred =>{
          if(cred.issuer == environment.cwSSO.authority) {
            this.ssoConnected = true;
          } else {
            this.onlyHasCwSsoCreds = false;
          }
        })

        this.hideSpinner();
        super.onLoad();
      }
    );
  }

  connectCwSso() {
    this._oidcCwService.getManager().signinPopup().then(res => {
      this._sessionService.setAuthenticationType(AuthenticationType.COGNITO);
      this._apiService.linkSsoToSpecificAccount(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id, res.id_token).subscribe(() => {
        this.onLoad();
      });
    });
  }

  disconnectCwSso() {
    if(this._sessionService.getAuthenticationType() == AuthenticationType.SSOJWT) {
      this.showPrompt('You are currently logged in through ConnectWise SSO. \
      You will be logged out if you disconnect ConnectWise SSO from this Identify account. \
      Would you like to continue?', (result) => {
        if(result) {
          this.continueDisconnectCwSso();
        }
      });
    } else {
      this.continueDisconnectCwSso();
    }
  }

  continueDisconnectCwSso() {
    this.showSpinner('Disconnecting...');
    this.userCreds.forEach(cred => {
      if(cred.issuer == environment.cwSSO.authority) {
        this._apiService.deleteAccountUserCredential(this._sessionService.getCurrentAccount().id, this._sessionService.getCurrentUser().id, cred.id).subscribe(res => {
            this.ssoConnected = false;
            this.hideSpinner();
            if(this._sessionService.getAuthenticationType() == AuthenticationType.SSOJWT) {
              this._router.navigate(['/public/logout']);
              this.eventHandler.emit({ state: 'FORCECLOSE' });
            }
          }
        )
      }
    });
  }

  isDirty() {
    return false;
  }

  isValid() {
    return true;
  }
}